<template>
	<div class="cata-log"  @click="routeRead()">
		<div class="cata-log-view">
			<div class="cata-top">
				<img class="cata-top-image" :src="bookinfo.bookLogoUrl" alt="">
				<div class="cata-top-view">
					<p class="cata-top-text">{{bookinfo.bookName}}</p>
					<!-- <span class="cata-top-text">{{bookinfo.bookAuthor}} 著</span> -->
					<span class="cata-top-text">{{bookinfo.bookFinish===1?'连载':'完结'}}</span>
				</div>
			</div>
			<div class="cata-content">
				<div class="cata-title">
					<span class="cata-title-total">共{{total}}章</span>
							<!-- #ifdef H5 -->
					<div @click.stop="selectCata" class="cata-text">
						<span class="cata-text-title">第{{selectText}}章</span>
						<img class="cata-arrow " :class="isShowSelect?'cata-arrow-active':''"
							src="../../../../static/arrow.png" alt="">
						<div class="cata-select" v-if="isShowSelect">
							<span class="cata-select-text" v-for="(item,index) in selectList" @click.stop="chooseCata(item,index)" :key="index">第{{item}} 章</span>
						</div>
					</div>
					<!-- #endif -->
				</div>
				<div class="content-box" ref="scroll">
					<div class="scroller">
					<div :id="'list'+item.id"  class=" content-box-view" v-for="(item,index) in cataList" :key="index" @click.stop="routeRead(item)">
						<span class="content-box-text" :class="chapterorder==item.chapterOrders?'chapter-cative':''">第{{item.chapterOrders}}章 {{item.chapterName}}</span>
						<img v-if="item.txtIsCharge===1" class="lock-image" src="../../../../static/lock_icon.png" alt="">
					</div>
				
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	 
	export default {
		props: {
			bookinfo: {
				type: Object,
				default: {}
			},
			bookid: {
				type: String,
				default: ''
			},
			chapterorder: {
				type: Number,
				default: 0
			},
		},
		data() {
			return {
				total: 1,
				bookId: 0,
				pageNo: 1,
				cataList: [],
				selectList: [],
				pageCount: 1,
				selectText: '',
				isShowSelect: false
			}
		},
		mounted() {
			if (this.chapterorder) {
				this.pageNo = Math.ceil(this.chapterorder / 100)
			}
			this.getBookCatlogs()
		
		},
		methods: {
		scrollToBottom(scrollTop){
        this.$nextTick(()=>{
         let box = this.$el.querySelector(".content-box")
		 console.log(box)
		  box.scrollTo(0, scrollTop);
		 console.log( box.scrollTop )
        })
       },
			getBookCatlogs() {
				var params = {
					order: 0,
					bookId: this.bookinfo.id,
					pageNo: this.pageNo,
					pageSize: 100
				}
			
				this.$api.getBookCatlogs(params).then(res => {
					if (res.status == 1) {
						this.total = res.counts;
						this.pageCount = res.pages;
						this.selectList = [];
						for (var j = 0; j < res.pages; j++) {
							if (j == res.pages - 1) {
								if (this.total == ((j * 100) + 1)) {
									this.selectList.push((j * 100) + 1)
								} else {
									this.selectList.push((j * 100) + 1 + '-' + this.total)
								}
							} else {
								this.selectList.push((j * 100) + 1 + '-' + (j + 1) * 100)
							}
						}
						this.cataList = res.data;
						for (var i = 0; i < this.selectList.length; i++) {
							if (this.pageNo == i + 1) {
								this.selectText = this.selectList[i]
							}
						}
						 var scrollTop = 0;
						this.cataList.forEach((item) => {
							console.log(this.chapterorder)
							if (item.chapterOrders == this.chapterorder) {
								console.log(item.chapterOrders)
								console.log(this.chapterorder % 100)
								if(this.chapterorder % 100==0){
									// 
									scrollTop = 100 * 47;
								}else{
									scrollTop = ((this.chapterorder % 100) - 1) * 47;
								}
							}
						});
						console.log(scrollTop)
							this.scrollToBottom(scrollTop);
					}
				})
			},
			selectCata() {
				this.isShowSelect = !this.isShowSelect
			},
			chooseCata(item, index) {
				this.selectText = item;
				this.pageNo = index + 1;
				this.isShowSelect = false;
				this.getBookCatlogs();
			},
			routeRead(item) {
				this.$emit('emitEvt', {
					data: item
				})
			}
		}
	}
</script>

<style scoped>
	.cata-log {
		position: fixed;
		left: 0px;
		top: 0px;
		width: 100%;
		height: 100%;
		z-index:999;
		background-color: rgba(0, 0, 0, .5);
	}
	.cata-log-view {
		background-color: #FFFFFF;
		width: 75%;
		height: 100%;
	}

	.cata-top {
		padding: 20px 16px 16px 12px;
		border-bottom: 1px solid #F0F0F0;
		display: flex;
	}

	.cata-top-image {
		width: 69px;
		height: 89px;
		border-radius: 8px;
	}

	.cata-top-text {
		display: block;
	}
	.cata-top-view {
		margin-left: 12px;
		position: relative;
	}
	.cata-top .cata-top-text:nth-child(1) {
		font-size: 18px;
		color: #333333;
		font-weight: bold;
		text-overflow: ellipsis;
		overflow: hidden;
		-webkit-line-clamp:2;
		-webkit-box-orient: vertical;
		display: -webkit-box;
	}
	.cata-top .cata-top-text:nth-child(2) {
		width: 50px;
		height: 20px;
		border-radius: 20px;
		background: rgba(222, 59, 52, 0.20);
		color: #DE3B34;
		font-size: 12px;
		text-align: center;
		line-height:20px;
		margin-top: 20px;
		position: absolute;
		left:0px;
		bottom: 0px;
	}

	.cata-title {
		padding: 9px 0px 9px 16px;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #F3F3F3;
		width: 100%;
		background-color: #FFFFFF;
		box-sizing: border-box;
	}

	.cata-title-total {
		font-size: 14px;
		color: #888888;
	}

	.cata-text {
		font-size: 14px;
		color: #333333;
		width: 128px;
		position: relative;
	}

	.cata-arrow {
		position: absolute;
		right: 15px;
		top: 7px;
		width: 6.1px;
		height: 4.4px;
	}

	.cata-arrow-active {
		transform: rotate(180deg);
	}

	.cata-text>.cata-text-title {
		display: block;
		font-size: 14px;
		color: #333333;
		padding: 0px 9px 0px 12px;
	}

	.cata-select {
		position: absolute;
		right: 0px;
		top:29px;
		background-color: #FFFFFF;
		z-index: 99;
		width: 100%;
		overflow-y: scroll;
		height: calc(100vh - 165px); 
		 padding-bottom: env(safe-area-inset-bottom);
		 
	}
	.cata-select-text {
		display: block;
		padding: 18px 9px 4px 12px;
	}
	.cata-content {
		/* height:calc(100vh – 120px) */
			background: #F3F3F3;
	}
	.content-box {
		padding:0 16px;
		/* height: 1100px; */
		height: 90%;
		/* padding-bottom:20px; */
		overflow-y: scroll;
	}
	.content-box-view {
		display: flex;
		justify-content: space-between;
		padding-top: 20px;
		padding-bottom: 8px;
	}
	.content-box-text {
		font-size: 14px;
		color: #666666;
		text-overflow: ellipsis;
		width: 223px;
		white-space: nowrap;
		overflow: hidden;
	}

	.lock-image {
		width: 18px;
		height: 21px;
	}

	.content-box .chapter-cative {
		color: #DE3B34;
		font-weight: bold;
	}
		 .content-box{
		 height: calc(100% - 50px);   
	 }
		 .cata-content {
	height: calc(100vh - 126px);
	}

</style>



// WEBPACK FOOTER //
// src/view/bookRead/component/cata_component.vue